import { getStylesObjFromCss } from "../../../../../utils/common/styling";

export const styles = getStylesObjFromCss({
  styles: {
    img: {
      borderRadius: "50%",
      objectFit: "cover",
      minWidth: "44px",
      minHeight: "44px",
    },
    commenterAlphabetIcon: {
      minWidth: "44px",
      width: "44px",
      minHeight: "44px",
      height: "44px",
      borderRadius: "50%",
      color: "white",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      textTransform: "uppercase",
      fontSize: "1rem",
      fontWeight: 900,
    },
  },
  componentName: "CommenterImg",
});
